// extracted by mini-css-extract-plugin
module.exports = {"root":"Settings_root__2M4H9","search":"Settings_search__2hPjd","filter":"Settings_filter__B9T8X"};